module.exports = __webpack_public_path__ + "img/logo_dark@2x.4aae9bb3.png";